// Mailchimp client-side configuration.
//
// NOTE: MAILCHIMP_API_KEY and MAILCHIMP_AUDIENCE_ID are server-side only: never
// prefix them with REACT_APP_. This file only holds client-safe settings.
//
// Connected Sites snippet: enables popup forms and site activity tracking.
// Find both IDs in: Mailchimp Dashboard → Audience → Connected Sites → Add site → JS snippet
// The snippet src has the form:
//   https://chimpstatic.com/mcjs-connected/js/users/{userId}/{siteId}.js
//
//   REACT_APP_MAILCHIMP_USER_ID: your Mailchimp org/user ID (shared across all your sites)
//   REACT_APP_MAILCHIMP_SITE_ID: the Connected Site ID (unique per connected domain)

const userId = process.env.REACT_APP_MAILCHIMP_USER_ID;
const siteId = process.env.REACT_APP_MAILCHIMP_SITE_ID;

export const embedScriptSrc =
  userId && siteId
    ? `https://chimpstatic.com/mcjs-connected/js/users/${userId}/${siteId}.js`
    : null;
